import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from './createContext';
import ReactGA from 'react-ga';
import axios from 'axios';
import { signUp } from '../constants/api';
const windowGlobal = typeof window !== 'undefined' && window;

const DEFAULT_PARTNERS = {
  HomeBay: {
    selected: false,
  },
  Redefy: {
    selected: false,
  },
  Rex: {
    selected: false,
  },
};

class AppProvider extends Component {
  state = {
    progress: 0,
    steps: 3,
    submitted: false,

    userId: null,
    setUserId: id => {
      this.setState({
        userId: id,
      });
    },

    isEmailSubmitted: false,
    setIsEmailSubmitted: () => {
      this.setState({
        isEmailSubmitted: true,
      });

      ReactGA.event({
        category: 'Sign Up Flow',
        action: 'Email Submitted',
      });
    },

    queryParams: null,
    setQueryparams: params => {
      this.setState({
        queryParams: params,
      });
    },

    dynamicLocation: null,
    setDynamicLocation: data => {
      this.setState({
        dynamicLocation: data,
      });
    },

    partners: null,
    setPartners: partners => {
      const partnersShape = Array.isArray(partners)
        ? partners.reduce((acc, curr) => {
            acc[curr] = {
              selected: false,
            };

            return acc;
          }, {})
        : DEFAULT_PARTNERS;

      this.setState({
        partners: partnersShape,
      });
    },
    togglePartner: partner => {
      this.setState(state => {
        return {
          partners: {
            ...state.partners,
            [partner]: {
              selected: !state.partners[partner].selected,
            },
          },
        };
      });

      ReactGA.event({
        category: 'Sign Up Flow',
        action: 'Toggle Partner',
      });
    },

    address: null,
    setAddress: address => {
      this.setState({
        address: address,
      });
    },

    howSoon: null,
    setHowSoon: (months, progress) => {
      this.setState({
        howSoon: months,
        progress,
      });

      windowGlobal.CE2.converted('62ddf23d-25a7-4c97-8575-639f24d43f64');

      ReactGA.event({
        category: 'Sign Up Flow',
        action: `How Soon - ${months}`,
      });
    },

    salesMethod: null,
    setSalesMethod: (salesMethod, progress) => {
      this.setState({
        salesMethod,
        progress,
      });

      ReactGA.event({
        category: 'Sign Up Flow',
        action: `Sales Method - ${salesMethod}`,
      });
    },

    userEmail: null,
    setUserEmail: userEmail => {
      this.setState({
        userEmail,
      });

      ReactGA.event({
        category: 'Sign Up Flow',
        action: 'Set User Email',
      });
    },

    goFwd: () => {
      this.setState(state => ({
        progress: state.progress + 1,
      }));

      ReactGA.event({
        category: 'Sign Up Flow',
        action: 'Fwd Button',
      });
    },

    submitCampaign: async () => {
      const params = {
        address: this.state.address ? this.state.address.description : null,
        howSoon: this.state.howSoon,
        salesMethod: this.state.salesMethod,
        selectedPartners:
          Object.keys(this.state.partners).filter(
            partner => this.state.partners[partner].selected
          ) || 'No local partners',
        userId: this.state.userId,
        email: this.state.userEmail,
      };

      const result = await axios.post(signUp('dev'), params);

      if (result.status === 200) {
        this.setState({
          submitted: true,
        });

        ReactGA.event({
          category: 'Sign Up Flow',
          action: 'Campaign Submitted',
        });
      }
    },
  };

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>;
  }
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppProvider;
